// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  offsiteLocations: [],
  totalOffsiteLocations: 0,
}

export const mutations = {
  SET_OFFSITE_LOCATIONS(state, offsiteLocations) {
    state.offsiteLocations = offsiteLocations
  },
  SET_TOTAL_OFFSITE_LOCATIONS(state, total) {
    state.totalOffsiteLocations = total
  },
  ADD_OFFSITE_LOCATION(state, offsiteLocation) {
    state.offsiteLocations.push(offsiteLocation)
  },
  EDIT_OFFSITE_LOCATION(state, offsiteLocation) {
    const index = state.offsiteLocations.findIndex(
      (el) =>
        el.client_site_location_uuid ===
        offsiteLocation.client_site_location_uuid
    )
    if (index !== -1) {
      state.offsiteLocations.splice(index, 1, offsiteLocation)
    }
  },
  DELETE_OFFSITE_LOCATION(state, client_site_location_uuid) {
    const index = state.offsiteLocations.findIndex(
      (el) => el.client_site_location_uuid === client_site_location_uuid
    )
    if (index !== -1) state.offsiteLocations.splice(index, 1)
  },
}

export const actions = {
  fetchOffsiteLocations({ commit }, payload) {
    return ApiService.fetchOffsiteLocations(payload)
      .then((res) => {
        const { data, total } = res.data
        commit('SET_OFFSITE_LOCATIONS', data)
        commit('SET_TOTAL_OFFSITE_LOCATIONS', total)
      })
      .catch((error) => {
        throw error
      })
  },
  addOffsiteLocation({ commit }, payload) {
    return ApiService.addOffsiteLocation(payload)
      .then((res) => {
        const offsiteLocation = res.data
        commit('ADD_OFFSITE_LOCATION', offsiteLocation)
      })
      .catch((error) => {
        throw error
      })
  },
  editOffsiteLocation({ commit }, payload) {
    return ApiService.editOffsiteLocation(payload)
      .then((res) => {
        const offsiteLocation = res.data
        commit('EDIT_OFFSITE_LOCATION', offsiteLocation)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteOffsiteLocation({ commit }, payload) {
    return ApiService.deleteOffsiteLocation(payload)
      .then(() => {
        commit('DELETE_OFFSITE_LOCATION', payload.client_site_location_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}
